import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import {
  Box,
  Icon,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  styled,
} from "@mui/material";
import { green, red } from "@mui/material/colors";
import { RolesName } from "configs/roles";
import { useMemo, useState } from "react";
import { toast } from "react-toastify";
import { setOperatorPhone } from "utils/action/user";
import {
  NoRecordField,
  setTitleCase,
} from "../../../components/template/partials";
import { useUserManagementUIContext } from "../UserManagementUIContext";

const StyledTable = styled(Table)(() => ({
  whiteSpace: "pre",
  "& thead": {
    "& tr": { "& th": { paddingLeft: 0, paddingRight: 0 } },
  },
  "& tbody": {
    "& tr": {
      "& td": {
        paddingLeft: 0,
        paddingTop: "2px",
        paddingBottom: 0,
      },
    },
  },
}));

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export function UserListTable() {
  const userUIContext = useUserManagementUIContext();
  const accountUIProps = useMemo(() => {
    return {
      queryParams: userUIContext.queryParams,
      getListUsersData: userUIContext.getListUsersData,
      setQueryParams: userUIContext.setQueryParams,
      goToDeleteUser: userUIContext.goToDeleteUser,
      goToUserEdit: userUIContext.goToUserEdit,
      goToUserChangePass: userUIContext.goToUserChangePass,
    };
  }, [userUIContext]);
  const {
    queryParams,
    getListUsersData,
    goToDeleteUser,
    goToUserEdit,
    goToUserChangePass,
    setQueryParams,
  } = accountUIProps;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClickDelete = (item) => {
    goToDeleteUser(item);
  };
  const handleClickChangePass = (item) => {
    goToUserChangePass(item);
  };
  const handleClickEdit = (item) => {
    goToUserEdit(item);
  };
  const handleAdminWhatsapp = async (item) => {
    const request = {
      username: item.username,
      nomor_operator: item.email_nohp,
    };

    try {
      await setOperatorPhone(request);
      toast.success(setTitleCase("berhasil setting nomor admin operator"));
      setQueryParams(queryParams);
    } catch (error) {
      toast.error(setTitleCase(error.response.data?.message));
    }
  };

  return (
    <Box width="100%" overflow="auto">
      <StyledTable className="table-container">
        <TableHead className="table-header">
          <TableRow>
            <TableCell className="table-content-xs text-white" align="center">
              No
            </TableCell>
            <TableCell className="table-content-lg text-white" align="center">
              Nama User
            </TableCell>
            <TableCell className="table-content-md text-white" align="center">
              Role
            </TableCell>
            <TableCell className="table-content-md text-white" align="center">
              NomorHP
            </TableCell>
            <TableCell className="table-content-md text-white" align="center">
              Action
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {getListUsersData.isFulfilled &&
            !getListUsersData.isLoading &&
            stableSort(getListUsersData.data, getComparator("asc", "username"))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((item, index) => (
                // {getListUsersData.data?.slice(page*rowsPerPage, page* rowsPerPage + rowsPerPage).map((item, index) => (
                <TableRow hover key={item.username}>
                  <TableCell className="table-content-xs" align="center">
                    {NoRecordField(index + 1 + page * rowsPerPage)}
                  </TableCell>
                  <TableCell className="table-content-lg" align="center">
                    {NoRecordField(item.username)}
                  </TableCell>
                  <TableCell className="table-content-md" align="center">
                    {NoRecordField(item.role)}
                  </TableCell>
                  <TableCell className="table-content-md" align="center">
                    {NoRecordField(item.email_nohp)}
                  </TableCell>
                  <TableCell className="table-content-md" align="center">
                    {item.role.toUpperCase() === RolesName.ROLES_OPERATOR && (
                      <IconButton onClick={() => handleAdminWhatsapp(item)}>
                        <WhatsAppIcon
                          className="icon"
                          sx={{
                            color: green[500], // Ubah warna ke biru jika ada nomor, jika tidak tetap hijau
                            border:
                              item.nomor_operator !== ""
                                ? "3px solid green"
                                : "none", // Tambah border jika ada nomor
                          }}
                        />
                      </IconButton>
                    )}
                    <IconButton onClick={() => handleClickEdit(item)}>
                      <Icon className="icon" sx={{ color: green[500] }}>
                        edit
                      </Icon>
                    </IconButton>
                    <IconButton onClick={() => handleClickChangePass(item)}>
                      <Icon className="icon" sx={{ color: green[500] }}>
                        key
                      </Icon>
                    </IconButton>
                    <IconButton onClick={() => handleClickDelete(item)}>
                      <Icon className="icon" sx={{ color: red[500] }}>
                        delete
                      </Icon>
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
        </TableBody>
      </StyledTable>
      <TablePagination
        sx={{ px: 2 }}
        component="div"
        rowsPerPage={rowsPerPage}
        page={page}
        count={getListUsersData.count}
        onPageChange={handleChangePage}
        rowsPerPageOptions={[5, 10, 20]}
        onRowsPerPageChange={handleChangeRowsPerPage}
        nextIconButtonProps={{ "aria-label": "Next Page" }}
        backIconButtonProps={{ "aria-label": "Previous Page" }}
      />
    </Box>
  );
}
